import React, { useEffect, useState } from "react";
import {
  getApiBaseUrl,
  ADD_WASH_IN,
  ADD_ACTIVITY,
  LOGIN,
} from "../../Config/Config";
import Swal from "sweetalert2";
import axios from "axios";
import { Spin } from "antd";

const NewWashinReason = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));

  const [newReason, setNewReason] = useState({
    Reason: "",
    Category: "",
  });

  const [authLoading, setAuthLoading] = useState(false);
  const [askPassword, setAskPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const handleAuth = async () => {
    if (!password) {
      setError("Please enter your password.");
      return;
    }

    setAuthLoading(true);
    setError("");

    try {
      if (!user?.UserName) {
        throw new Error("User name not found in session data.");
      }

      const payload = {
        username: user.UserName,
        password,
      };

      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status) {
        setAskPassword(false);
        setPassword("");
        await handleAddWashInReasonSubmit();
      } else {
        throw new Error(
          data.Message || "Invalid credentials. Please try again."
        );
      }
    } catch (err) {
      setError(err.message || "Unable to authenticate. Please try again.");
    } finally {
      setAuthLoading(false);
    }
  };

  const handleAddWashInReasonSubmit = async () => {
    const payload = {
      ...newReason,
      CreatedBy: user?.UserID,
    };

    let isSuccess = 0;

    try {
      await axios.post(`${getApiBaseUrl()}${ADD_WASH_IN}`, payload);
      isSuccess = 1;

      // Call audit log BEFORE showing success Swal
      await axios.post(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        ActivityType: 1,
        PerformedBy: user?.UserID,
        PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
        Notes: `Wash-In Reason "${newReason?.Reason}" created successfully`,
        Location: "AddWashInReason",
        IsSucces: isSuccess,
      });

      // Show Swal and reload after user confirms
      Swal.fire(
        "Success",
        "Wash-In Reason added successfully.",
        "success"
      ).then(() => {
        window.location.reload();
      });

      // Clear form data
      setNewReason({ Reason: "", Category: "" });
    } catch (error) {
      // Audit log for failure
      await axios.post(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        ActivityType: 1,
        PerformedBy: user?.UserID,
        PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
        Notes: `Wash-In Reason "${newReason?.Reason}" creation failed`,
        Location: "AddWashInReason",
        IsSucces: isSuccess,
      });

      Swal.fire("Error", "Failed to add reason.", "error");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user?.UserID) {
      setError("Invalid user data. Please log in again.");
      Swal.fire({
        icon: "error",
        title: "User Data Error",
        text: "Invalid user data. Please log in again.",
      });
      return;
    }

    setAskPassword(true);
  };

  const clearUserData = () => {
    setNewReason({ Reason: "", Category: "" });
    setError("");
  };

  useEffect(() => {
    const offcanvas = document.getElementById("AddWashInReasonOffcanvas");
    if (offcanvas) {
      const handleClose = () => {
        clearUserData();
      };
      offcanvas.addEventListener("hidden.bs.offcanvas", handleClose);
      return () => {
        offcanvas.removeEventListener("hidden.bs.offcanvas", handleClose);
      };
    }
  }, []);

  return (
    <div>
      {authLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="AddWashInReasonOffcanvas"
        aria-labelledby="AddWashInReasonOffcanvasLabel"
      >
        <form onSubmit={handleSubmit}>
          <div className="offcanvas-header">
            <h5 id="AddWashInReasonOffcanvasLabel" className="me-4">
              Add Wash-in Reason
            </h5>
            <div className="d-flex align-items-center ms-auto">
              <button
                type="submit"
                className="btn btn-sm btn-outline-success me-2"
                title="Save"
              >
                <i className="fa fa-check fs-4"></i>
              </button>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
          </div>
          <div className="offcanvas-body">
            <div className="mb-3">
              <label htmlFor="reason" className="form-label">
                Reason
              </label>{" "}
              <span className="text-danger ms-1">*</span>
              <input
                type="text"
                className="form-control"
                id="reason"
                value={newReason.Reason}
                onChange={(e) =>
                  setNewReason({
                    ...newReason,
                    Reason: e.target.value,
                  })
                }
                required
                placeholder="Enter Wash-In Reason"
              />
            </div>
            {askPassword && (
              <div className="mt-2">
                <div className="mb-3 w-lg-75 m-auto">
                  <label className="form-label">
                    Confirm Password <span className="text-danger"> *</span>
                  </label>
                  <div className="pass-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="pass-input form-control"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        setError("");
                      }}
                      onCopy={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()}
                      placeholder="Enter Password"
                    />
                    <span
                      className={`ti toggle-password ${
                        showPassword ? "ti-eye" : "ti-eye-off"
                      }`}
                      onClick={() => setShowPassword(!showPassword)}
                    ></span>
                  </div>
                </div>
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={handleAuth}
                  disabled={authLoading || !password}
                >
                  {authLoading ? "Verifying..." : "Confirm"}
                </button>
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => {
                    setAskPassword(false);
                    setPassword("");
                    setError("");
                  }}
                >
                  Cancel
                </button>
              </div>
            )}
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewWashinReason;
